import React from "react";

import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import InstagramIcon from "@material-ui/icons/Instagram";
import FacebookIcon from "@material-ui/icons/Facebook";

const ConnectionIcon = ({ connectionType }) => {
    // Normalizar o tipo de conexão para minúsculas para evitar problemas com caixa alta/baixa
    const normalizedType = connectionType?.toLowerCase() || "";

    return (
        <React.Fragment>
            {normalizedType === 'whatsapp' && <WhatsAppIcon fontSize="small" style={{ marginBottom: '-5px', color: "#25D366" }} />}
            {normalizedType === 'instagram' && <InstagramIcon fontSize="small" style={{ marginBottom: '-5px', color: "#e1306c" }} />}
            {normalizedType === 'facebook' && <FacebookIcon fontSize="small" style={{ marginBottom: '-5px', color: "#3b5998" }} />}
            {normalizedType === 'fzap' && (
                <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
                    <WhatsAppIcon fontSize="small" style={{ marginBottom: '-5px', color: "#25D366" }} />
                    <span style={{
                        position: 'absolute',
                        bottom: '-2px',
                        right: '-6px',
                        backgroundColor: '#22c55e',
                        color: 'white',
                        fontSize: '8px',
                        fontWeight: 'bold',
                        borderRadius: '50%',
                        width: '12px',
                        height: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: '1px solid white'
                    }}>
                        F
                    </span>
                </div>
            )}
        </React.Fragment>
    );
};

export default ConnectionIcon;
